export const SUBMENU_PRIVILLAGE_REQUEST = "SUBMENU_PRIVILLAGE_REQUEST"
export const SUBMENU_PRIVILLAGE_SUCCESS = "SUBMENU_PRIVILLAGE_SUCCESS"
export const PASSPORT_SUBMENU_PRIVILLAGE_REQUEST = "PASSPORT_SUBMENU_PRIVILLAGE_REQUEST"
export const PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS = "PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS"